import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconThermostat: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconThermostat"><Path fillRule="evenodd" clipRule="evenodd" d="M15 3H20V5H15V3ZM15 7H20V9H15V7ZM15 11H20V13H15V11Z" fill="currentColor"/><Path d="M11 2H7V12.416C5.2341 13.1876 4 14.9497 4 17C4 19.7614 6.23858 22 9 22C11.7614 22 14 19.7614 14 17C14 14.9497 12.7659 13.1876 11 12.416V2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconThermostat;
